import styled from "@emotion/styled";
import { ButtonLink } from "./ButtonLink";

export const NavLinkButton = styled(ButtonLink)`
  text-transform: uppercase;
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  background-color: transparent;
  color: ${(p) => p.theme.palette.primary.main};
  box-shadow: none;
  border-radius: 5px;

  &:hover {
    background-color: rgba(43, 51, 255, 0.04);
    box-shadow: none;
  }
`;
